import React from 'react'
import { Box, Flex } from '@chakra-ui/core'
import styled from '@emotion/styled'
import { AdminSidebar } from './AdminSidebar'
import { Outlet, useLocation } from 'react-router-dom'

const AdminContainer = styled(Flex)`
  min-height: 100vh;
  background-color: white;
`

const MainContent = styled(Box)`
  flex: 1;
  height: 100vh;
  overflow-y: auto;
  @media (max-width: 768px) {
    padding: 0.5rem;
  }
`

export const AdminConsole: React.FC = () => {
  const location = useLocation()
  const activeSection = location.pathname.split('/').pop() || 'users'

  return (
    <AdminContainer>
      <AdminSidebar activeSection={activeSection} />
      <MainContent>
        <Box p="1rem">
          <Outlet />
        </Box>
      </MainContent>
    </AdminContainer>
  )
}
